// extracted by mini-css-extract-plugin
export default {"container":"PD-z","dimension":"QD-z","dimensionLabels":"RD-z"};